import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CompanyInfo } from '@/components/settings/company';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/company')({
  component: Company,
});

function Company() {
  const [name, setName] = useState<string>('');
  const [url, setUrl] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('+');

  const [country, setCountry] = useState<string>('');
  const [language, setLanguage] = useState<string>('');

  return (
    <div className='pt-6 space-y-6'>
      <CompanyInfo
        name={name}
        onNameChange={setName}
        url={url}
        onUrlChange={setUrl}
        email={email}
        onEmailChange={setEmail}
        phone={phone}
        onPhoneChange={setPhone}
        country={country}
        onCountryChange={setCountry}
        language={language}
        onLanguageChange={setLanguage}
      />
    </div>
  );
}
